module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'block') ? _c('label', {
    staticClass: "ts-radio",
    class: [{
      'is-active': _vm.model === _vm.label
    }, {
      'is-disbaled': _vm.isDisabled
    }, {
      'is-origin': _vm.type === 'origin'
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "ts-radio-input",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.isDisabled,
      "title": _vm.title
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm.model, _vm.label)
    },
    on: {
      "__c": function($event) {
        _vm.model = _vm.label
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ts-radio--inner",
    style: (_vm.value === _vm.label ? _vm.activeStyle : null)
  }, [_vm._t("default")], 2)]) : _c('span', {
    staticClass: "ts-radio--origin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm.model, _vm.label)
    },
    on: {
      "__c": function($event) {
        _vm.model = _vm.label
      }
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-39923b0b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/radio/tsRadio.vue
// module id = 822
// module chunks = 39